import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import HsySettingsHtml from './hsy.settings.html';

export function HsyStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'HsySettingsCtrl',
    name       : 'app.hsy-settings',
    templateUrl: HsySettingsHtml,
    url        : '/hsy_settings',
    resolve    : {
      integrations: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      session     : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh()
    }
  });
}